(() => {
  const setupReveal = () => {
    const items = document.querySelectorAll('[data-reveal]');
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    items.forEach(el => el.classList.add('is-visible'));
    document.documentElement.classList.remove('reveal-enabled');
    if (document.documentElement.dataset.reveal !== 'true' || isMobile || reduceMotion) {
      return;
    }
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) {
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        if (el.dataset.revealAnimated !== 'true') {
          const direction = el.dataset.reveal;
          const x = direction === 'left' ? '-34px' : direction === 'right' ? '34px' : '0px';
          el.animate([
            { transform: `translate3d(${x}, 26px, 0)`, filter: 'blur(5px)', clipPath: 'inset(0 0 8% 0)' },
            { transform: 'translate3d(0, 0, 0)', filter: 'blur(0)', clipPath: 'inset(0 0 0 0)' }
          ], { duration: 760, delay: Number(el.dataset.revealDelay || 0), easing: 'cubic-bezier(.16,1,.3,1)', fill: 'none' });
          el.dataset.revealAnimated = 'true';
        }
        observer.unobserve(el);
      }
    }), { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    items.forEach((el, i) => { el.dataset.revealDelay = String((i % 4) * 70); observer.observe(el); });
  };
  const setupMenu = () => document.querySelectorAll('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav?.toggleAttribute('data-open');
    button.setAttribute('aria-expanded', String(Boolean(open)));
  }));
  const setupQuantity = () => document.querySelectorAll('[data-quantity]').forEach(group => group.addEventListener('click', e => {
    const button = e.target.closest('button'); if (!button) return;
    const input = group.querySelector('input'); const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step)); input.value = next;
  }));
  document.addEventListener('DOMContentLoaded', () => {
    const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
    document.documentElement.dataset.reveal = isThemeEditor ? 'false' : (document.body.dataset.reveal || 'true');
    if (isThemeEditor) document.documentElement.classList.add('shopify-design-mode');
    setupReveal(); setupMenu(); setupQuantity();
  });
  document.addEventListener('shopify:section:load', setupReveal);
})();
